import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'Skeleton',
  props: {
    blocks: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blocks, (block, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass([block.class, "animate-pulse bg-racq-pale-blue-border mx-auto max-w-full"]),
      style: _normalizeStyle({
      height: block.height + 'px',
      width: block.width + 'px',
      margin: block.margin,
    })
    }, null, 6))
  }), 128))
}
}

})